import { Link } from "gatsby";
import React from "react";
import {
  Container,
  Divider,
  Grid,
  Header,
  List,
  Segment,
} from "semantic-ui-react";

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => {
  return (
    <Segment
      as="footer"
      style={{ flexShrink: 0, margin: "5rem 0 0", padding: "2rem 0 0" }}
    >
      <Container textAlign="center">
        <Grid divided stackable>
          <Grid.Column width={4}>
            <Header as="h4" content="Site Links" />
            <List link>
              <List.Item as={Link} to="/">
                Home
              </List.Item>
              <List.Item as={Link} to="/articles">
                Articles
              </List.Item>
              <List.Item as={Link} to="/courses" disabled>
                Courses
              </List.Item>
              <List.Item as={Link} to="/dashboard">
                Dashboard
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width={8}>
            <Header inverted as="h4" content="Footer Header" />
            <p>Call to action</p>
          </Grid.Column>
          <Grid.Column width={4}>
            <Header as="h4" content="Social Links" />
            <List link>
              <List.Item as="a" href="mailto:support@learn2dev.com">
                Contact
              </List.Item>
              <List.Item
                as="a"
                href="https://twitter.com/CodeDraken"
                target="_blank"
              >
                Twitter
              </List.Item>
              <List.Item
                as="a"
                href="https://github.com/CodeDraken"
                target="_blank"
              >
                GitHub
              </List.Item>
              <List.Item
                as="a"
                href="https://patreon.com/Learn2Dev"
                target="_blank"
              >
                Patreon
              </List.Item>
            </List>
          </Grid.Column>
        </Grid>

        <Divider section />

        <p>© {new Date().getFullYear()} Learn2Dev, all rights reserved</p>
        <List horizontal divided link size="small">
          <List.Item as={Link} to="/about">
            About
          </List.Item>
          <List.Item as={Link} to="/terms">
            Terms and Conditions
          </List.Item>
          <List.Item as={Link} to="/privacy">
            Privacy Policy
          </List.Item>
        </List>
      </Container>
    </Segment>
  );
};

export default Footer;
